import { Fetcher } from '../../utils';

import {
  AUTH_LOGIN_ENDPOINT_CONF,
  AUTH_SIGN_UP_ENDPOINT_CONF,
  AUTH_LOGOUT_ENDPOINT_CONF,
  AUTH_ISSUE_MCP_TOKEN_ENDPOINT_CONF,
  AUTH_LIST_MCP_TOKENS_ENDPOINT_CONF,
  AUTH_REVOKE_MCP_TOKEN_ENDPOINT_CONF,
} from './endpoints';
import { IAuthLoginUser, IAuthSignUpUser, IIssuedMcpToken, IListedMcpToken } from './types';

export class AuthRepository {
  private fetcher: Fetcher;

  constructor(fetcher: Fetcher) {
    this.fetcher = fetcher;
  }

  public signUp(user: IAuthSignUpUser) {
    return this.fetcher.fetch<{ id: string }>({
      url: this.fetcher.buildURL(AUTH_SIGN_UP_ENDPOINT_CONF),
      method: 'POST',
      data: { ...user },
    });
  }

  public login(user: IAuthLoginUser) {
    return this.fetcher.fetch<void>({
      url: this.fetcher.buildURL(AUTH_LOGIN_ENDPOINT_CONF),
      method: 'POST',
      data: { ...user },
    });
  }

  public logout() {
    return this.fetcher.fetch<{ id: string }>({
      url: this.fetcher.buildURL(AUTH_LOGOUT_ENDPOINT_CONF),
      method: 'GET',
    });
  }

  public issueMcpToken(name: string) {
    return this.fetcher.fetch<IIssuedMcpToken>({
      url: this.fetcher.buildURL(AUTH_ISSUE_MCP_TOKEN_ENDPOINT_CONF),
      method: 'POST',
      data: { name },
    });
  }

  public listMcpTokens() {
    return this.fetcher.fetch<{ tokens: IListedMcpToken[] }>({
      url: this.fetcher.buildURL(AUTH_LIST_MCP_TOKENS_ENDPOINT_CONF),
      method: 'GET',
    });
  }

  public revokeMcpToken(tokenId: string) {
    // base статический не годится — нужен path-параметр. Spread'им основу и подменяем base.
    return this.fetcher.fetch<{ message: string }>({
      url: this.fetcher.buildURL({
        ...AUTH_REVOKE_MCP_TOKEN_ENDPOINT_CONF,
        base: `${AUTH_REVOKE_MCP_TOKEN_ENDPOINT_CONF.base}/${tokenId}/revoke`,
      }),
      method: 'POST',
    });
  }
}
